import type { FaireProductEntity } from "../../entity_types/product";

export const p_7fpm7cfcgx: FaireProductEntity = {
  token: "p_7fpm7cfcgx",
  type: "product",
  name: "GummiYums: Fun Shapez! (8.1oz) Assorted Gummy Candy Filled with a Sour Strawberry Center",
  brandToken: "b_8688sz59tv",
  brandName: "Showcase",
  imageUrl:
    "https://cdn.faire.com/fastly/394189f0fa21e519b509a82f2dcb905bf1feabe5ac6d0ecee113b3d2e551eea7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/87c0b2427142dcb8d98c2994f596ae08aa2366edfa6081d051354a0cbf2ab2f1.jpeg",
    "https://cdn.faire.com/fastly/c0b50fd7fcb94b84cfec0a355146d51ee69d6329a786714678754368b1c832ea.jpeg",
    "https://cdn.faire.com/fastly/808a99ff29fffb53edf4950ad7510b999dc7a3cb1f9dec7e1281fbc51304cc2c.jpeg",
    "https://cdn.faire.com/fastly/c16e01fcefe0fa29aac294abc58160a9d49249a1cbcfd697e3831973267f44fa.jpeg",
    "https://cdn.faire.com/fastly/a3876b9b838ff3bd55816698695f28bef2fea3812893b9d6e0dba4b8c0886b18.jpeg",
  ],
  priceDollars: 4.84,
  description:
    "The Gummy Candy That Always Brings A Smile!\n\nDelight your customers with GummiYums: Fun Shapez! – the ultimate gummy treat that combines playful shapes with bold, tangy flavor. Each gummy features a fun design, like ladybugs, monkeys, and emojis, filled with a sour strawberry center and bursting with real fruit jam in classic flavors such as watermelon, peach, and mango.\n\nGenerously sized and made with care, these gummies offer a unique chewy texture and an exciting burst of sweetness and sourness. Perfect for gummy candy lovers of all ages, GummiYums: Fun Shapez! adds a playful twist to your candy lineup and ensures a fun, flavorful experience with every bite.\n\nStock up today and watch these irresistible treats fly off the shelves!",
  tags: [],
  msrpDollars: 9.69,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:50.269Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
